import {
  rankingsAppPath,
} from '../../../util/paths';

export const rnkingsPath = `${rankingsAppPath}`;
export const newRankingPath = `${rankingsAppPath}/new`;
export const editRankingPath = `${rankingsAppPath}/:rankingId/edit`;
export const getEditRankingPath = rankingId => `${rankingsAppPath}/${rankingId}/edit`;
